// Runtime patches for Kendo UI behaviors used in RWF.
// Keep this file small and focused; it runs very early during bootstrap.

// Kendo Splitter (2019.x) renders splitbar icons using self-closing <div ... /> markup.
// In HTML parsing, non-void elements must not be self-closing; browsers may nest the
// subsequent tags which breaks CSS selectors and Kendo's direct-child event bindings.
//
// Fix: override Splitter::_updateSplitBar to emit valid <div></div> tags.

type JQueryLike = any;

(function patchKendoSplitterSplitbarMarkup() {
  const kendoAny = (globalThis as any).kendo;
  const Splitter = kendoAny && kendoAny.ui && kendoAny.ui.Splitter;
  const proto = Splitter && Splitter.prototype;
  if (!proto || typeof proto._updateSplitBar !== "function") {
    return;
  }

  // Patch only once.
  if (proto._rwfPatchedUpdateSplitBar) {
    return;
  }

  proto._rwfPatchedUpdateSplitBar = true;

  proto._updateSplitBar = function updateSplitBarPatched(splitbar: JQueryLike, prevPane: any, nextPane: any) {
    const icon = (classes: string, enabled: boolean) => (enabled ? "<div class='k-icon " + classes + "'></div>" : "");

    const orientation: string = this.orientation;
    const isHorizontal = orientation === "horizontal";

    const prevResizable = prevPane && prevPane.resizable !== false;
    const nextResizable = nextPane && nextPane.resizable !== false;
    const resizable = prevResizable && nextResizable;

    const prevCollapsible = !!(prevPane && prevPane.collapsible);
    const prevCollapsed = !!(prevPane && prevPane.collapsed);

    const nextCollapsible = !!(nextPane && nextPane.collapsible);
    const nextCollapsed = !!(nextPane && nextPane.collapsed);

    // Matches Kendo's original logic (see Splitter::_updateSplitBar) but with valid HTML.
    splitbar
      .addClass("k-splitbar k-state-default k-splitbar-" + orientation)
      .attr("role", "separator")
      .attr("aria-expanded", !(prevCollapsed || nextCollapsed))
      .removeClass("k-splitbar-" + orientation + "-hover")
      .toggleClass("k-splitbar-draggable-" + orientation, resizable && !prevCollapsed && !nextCollapsed)
      .toggleClass("k-splitbar-static-" + orientation, !resizable && !prevCollapsible && !nextCollapsible)
      .html(
        icon("k-collapse-prev k-i-arrow-60-up", prevCollapsible && !prevCollapsed && !nextCollapsed && !isHorizontal) +
          icon("k-collapse-prev k-i-arrow-60-left", prevCollapsible && !prevCollapsed && !nextCollapsed && isHorizontal) +
          icon("k-expand-prev k-i-arrow-60-down", prevCollapsible && prevCollapsed && !nextCollapsed && !isHorizontal) +
          icon("k-expand-prev k-i-arrow-60-right", prevCollapsible && prevCollapsed && !nextCollapsed && isHorizontal) +
          icon("k-resize-handle k-i-hbar", resizable && !isHorizontal) +
          icon("k-resize-handle k-i-vbar", resizable && isHorizontal) +
          icon("k-collapse-next k-i-arrow-60-down", nextCollapsible && !nextCollapsed && !prevCollapsed && !isHorizontal) +
          icon("k-collapse-next k-i-arrow-60-right", nextCollapsible && !nextCollapsed && !prevCollapsed && isHorizontal) +
          icon("k-expand-next k-i-arrow-60-up", nextCollapsible && nextCollapsed && !prevCollapsed && !isHorizontal) +
          icon("k-expand-next k-i-arrow-60-left", nextCollapsible && nextCollapsed && !prevCollapsed && isHorizontal)
      );

    if (!(resizable || prevCollapsible || nextCollapsible)) {
      splitbar.removeAttr("tabindex");
    }
  };
})();
